import { render, staticRenderFns } from "./GraduationSuccess.vue?vue&type=template&id=a59f964c&"
import script from "./GraduationSuccess.vue?vue&type=script&lang=js&"
export * from "./GraduationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports